import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useVideoPlayerStore = defineStore('videoPlayer', () => {
  const allowFullscreenOnRotate = ref(false);
  const isMuted = ref(true);

  const enableFullscreenOnRotate = () => {
    allowFullscreenOnRotate.value = true;
  };

  const disableFullscreenOnRotate = () => {
    allowFullscreenOnRotate.value = false;
  };

  return {
    isMuted,
    allowFullscreenOnRotate,
    enableFullscreenOnRotate,
    disableFullscreenOnRotate,
  };
});
